import { obtenerEquipo } from '@/data/equipos';
import { useMemo } from 'react';

/**
 * Hook para obtener información de un equipo por su ID
 * @param {number} teamId - ID del equipo
 * @returns {Object} - Objeto con información del equipo
 */
const useTeam = (teamId) => {
    const team = useMemo(() => {
        if (!teamId) {
            return {
                teamName: '',
                team: null,
            };
        }

        const foundTeam = obtenerEquipo(teamId);

        return {
            teamName: foundTeam?.name || '',
            team: foundTeam || null,
        };
    }, [teamId]);

    return team;
};

export default useTeam;
